import { getEventTransfer } from 'slate-react';
import defaultHtmlDeserializer from '../deserializers/defaultHtmlDeserializer';
import markdownDeserializer from '../deserializers/markdownDeserializer';
import dropboxPaperDeserializer from '../deserializers/dropboxPaperDeserializer';
import googleDocsDeserializer from '../deserializers/googleDocsDeserializer';
import defaultPlainTextDeserializer from '../deserializers/defaultPlainTextDeserializer';
import isPasteFromMSWord from '../utils/isPasteFromMSWord';
import ensureFragmentHasTextNode from './ensureFragmentHasTextNode';
export default function getFragmentFromEvent(editor, event) {
  var transfer = getEventTransfer(event);
  editor.command('addBreadcrumb', transfer, 'Slite Editor Paste');

  if (transfer.type === 'fragment') {
    // When copying from some versions of Slate, it tries to be smart and
    // serialize the document along-side the copied HTML. So when using their
    // getEventTransfer, it could pop out a fresh new fragment. As none of our
    // deserializers can handle the type "fragment", it will eventually fall
    // back to next(), who will then use this fragment.
    //
    // Slate. Come on. Don't be that lib.
    transfer.type = 'html';
  } else if (transfer.type === 'files' && isPasteFromMSWord(transfer)) {
    // MS Word put a copy of the text you copy as an image in the clipboard.
    // Depending on the clipboard data order, this might be considered as a file
    // and paste an image of the text.
    transfer.type = 'html';
  }

  var deserializer = [markdownDeserializer(editor, event), googleDocsDeserializer(editor), dropboxPaperDeserializer(editor), defaultHtmlDeserializer(editor), defaultPlainTextDeserializer(editor)].find(function (deserializer) {
    return deserializer.canDeserialize(transfer);
  });

  if (deserializer) {
    return ensureFragmentHasTextNode(editor, deserializer.deserialize(transfer).document);
  }
}